.bc{flex-wrap:wrap;}